<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <ResetForm />
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import ResetForm from '@/components/ResetForm.vue'

export default {
    name: 'Reset',
    components: {
        Header,
        Footer,
        ResetForm,
    },
}
</script>